export const tokenConstants = {
  USD: 'USD',
  USDC: 'USDC',
} as const;
